import { ActionIcon, Tooltip } from '@mantine/core';
import { Icon, variants, type SymbolCodepoints } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

import type { TranslationKey } from 'app/modules/wallforming/components/input-binding/types/translationKey';

interface SlotActionIconProps {
    icon: SymbolCodepoints;
    labelKey: TranslationKey;
    disabled?: boolean;
    disabledWithoutStyle?: boolean;
    active?: boolean;
    onClick: () => void;
    /** Extra attributes, e.g. the capture toggle marker. */
    attributes?: Record<`data-${string}`, boolean>;
}

export const SlotActionIcon = ({
    icon,
    labelKey,
    disabled,
    disabledWithoutStyle,
    active,
    onClick,
    attributes
}: SlotActionIconProps) => {
    const { t } = useTranslation();
    const useAriaDisabled = disabled && disabledWithoutStyle;
    return (
        <Tooltip disabled={disabled} label={t(labelKey)} zIndex={20000}>
            <ActionIcon
                aria-disabled={useAriaDisabled || undefined}
                aria-pressed={active}
                className={`action-icon-small focus:bg-transparent! ${useAriaDisabled ? 'cursor-not-allowed' : ''}`}
                disabled={disabled && !disabledWithoutStyle}
                size="xs"
                tabIndex={useAriaDisabled ? -1 : undefined}
                variant={
                    active ? variants.actionIcon.activated : disabled && !disabledWithoutStyle ? 'subtle' : 'default'
                }
                onClick={() => {
                    if (!disabled) {
                        onClick();
                    }
                }}
                {...attributes}
            >
                <Icon className="icon-xs" icon={icon} />
            </ActionIcon>
        </Tooltip>
    );
};
